export default __webpack_public_path__ + "static/media/hero6.98f9d9c0.png";